import SubHeading from "@/components/sections/SubHeading";
import React from "react";

interface InternsMember {
  name: string;
  role: string;
  image: string;
}

export default function Interns({ interns }: { interns: InternsMember[] }) {
  return (
    <div
      className="mx-auto p-6 lg:p-12"
      style={{ fontFamily: "Poppins, sans-serif" }}
    >
      <SubHeading top={"2025 Selected Intern Students"} />
      <div className="mx-auto mt-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {interns.map((member, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-3xl hover:shadow-2xl transition-all duration-300"
              style={{ aspectRatio: "3/4" }}
            >
              {/* Image Container */}
              <div className="absolute inset-0">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-300"
                />
                {/* Gradient Overlay */}
                <div
                  className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[var(--primary)] opacity-90"
                  style={{
                    background: `linear-gradient(to bottom, transparent 0%, transparent 50%, var(--primary) 100%)`,
                  }}
                ></div>
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white z-10">
                <h2 className="text-xl md:text-2xl font-bold mb-2">
                  {member.name}
                </h2>
                <p className="text-sm md:text-base opacity-90">{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
